import {Box, HBox} from '@buncha/components/core/view';
import {Divider, InfoOutlineIcon} from 'native-base';
import React, {useMemo} from 'react';

import {H6Text} from '@buncha/components/core/text';
import {HomeScreens} from '@buncha/home/navigation/types';
import If from '@buncha/components/conditional/If';
import {ListHeaderStyle} from './styles';
import {Modules} from '@buncha/utils/types';
import {PrinterMange} from '@buncha/components/type';
import PrinterSettingIcon from '@buncha/components/core/icon/PrinterSettingIcon';
import {Touchable} from '@buncha/components/core/touchable';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  infoToolTipHandler: () => void;
  printerSettingsModalHandler: () => void;
  hasDeviceSelected: boolean;
}

const ListHeader = (props: Props) => {
  const theme = useColorThemeType();

  const constatns = useAppSelector(gbState => gbState.onboarding.constants);
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  const currentUserId = useAppSelector(
    gState => gState.onboarding.currentUser?.id,
  );

  const gbDriverState = useAppSelector(gbState => gbState.driver);
  const disablePrinterFlow = gbDriverState.disablePrinterFlow;

  const hasPrinterEnabled = useMemo(() => {
    let printerMange: PrinterMange | undefined;
    try {
      printerMange =
        constatns?.PRINTER_MANAGE && JSON.parse(constatns?.PRINTER_MANAGE);
    } catch (err: any) {
      printerMange = undefined;
    }
    if (!printerMange || !currentUserId) return false;
    if (printerMange.allUsers) return true;
    return printerMange.users?.includes(currentUserId);
  }, [constatns?.PRINTER_MANAGE, currentUserId]);

  const getIconColor = useMemo(() => {
    if (props?.hasDeviceSelected) return theme?.icon.green[100];
    return theme?.icon.red[100];
  }, [props?.hasDeviceSelected, theme?.icon.green, theme?.icon.red]);

  return (
    <Box
      style={[
        ListHeaderStyle.container,
        {backgroundColor: theme?.background.white[100]},
      ]}>
      <HBox style={ListHeaderStyle.headerBox}>
        <HBox style={ListHeaderStyle.headerInnerBox}>
          <H6Text
            style={[
              ListHeaderStyle.headerText,
              {color: theme?.text?.blue[300]},
            ]}>
            {body?.loadOrders}
          </H6Text>
          <Touchable
            style={ListHeaderStyle.icon}
            onPress={props?.infoToolTipHandler}>
            <InfoOutlineIcon color={theme?.icon.blue[300]} />
          </Touchable>
        </HBox>
        <If condition={hasPrinterEnabled && !disablePrinterFlow}>
          <Touchable
            onPress={props?.printerSettingsModalHandler}
            style={ListHeaderStyle.printerSettingIcon}>
            <PrinterSettingIcon viewBox="-4 -4 25 25" fill={getIconColor} />
          </Touchable>
        </If>
      </HBox>
      <HBox style={ListHeaderStyle.sequenceBox}>
        <H6Text>{body?.vanLoadSequence}</H6Text>
        <H6Text>{body?.orderDetails?.[0]}</H6Text>
      </HBox>
      <Divider style={ListHeaderStyle.divider} />
    </Box>
  );
};

export default React.memo(ListHeader);
